import { Theme } from "../../Theme";

export const GenerPanelContainer = {
  display: "flex",
  justifyContent: "center",
  alignItem: "center",
};

export const Generpanel = {};

export const GenerPanelList = {
  // margin:"10px"
};

export const GenerPanelAgeGroup = {
  // margin:"10px"
};

export const GenerPanelSort = {
    minWidth: "13em",
  backgroundColor: Theme.white,
  height: "2.5rem",
  borderRadius: "5px",
  outline:"none"
    // borderRadius: "25%",
    // padding:"20px"
};

export const GenerPanelListButton = {
  margin: "10px",
  background: "transparent",
  boxShadow: "none",
};
export const GenerPanelAgeGroupButton = {
  margin: "10px",
  background: "transparent",
  boxShadow: "none",
};

